import styled from 'styled-components'

const ModalUserCreateRewardSettingStyled = styled.div`
  width: 1140px;
  position: relative;
  background-color: #4df285;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;

  .user-create_reward-setting-modal {
    background-color: ${({ theme }) => theme.color.neutral};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
    padding: 8px 30px 15px;
    position: relative;
    min-height: 500px;
    min-width: 100%;
    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: ${({ theme }) => theme.color.transparent};
      border: none;
      z-index: 1;
    }

    .line {
      border-bottom: 2px solid ${({ theme }) => theme.color.black};
    }

    .height-85 {
      height: 90px;
    }

    .height-45 {
      height: 45px;
      margin-top: 10px;
    }

    .title-create-reward-setting-container {
      padding-bottom: 10px;
      font-size: 30px;
      font-weight: 600;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
    }
    
    .create-reward-setting-container {
      color: #DEDEDE;
      // display: flex;
      // align-items: center;
      .ant-form {
        width: 100%;
      }

      .detail-reward-code-section {
        display: flex;
        align-items: center;
        gap: 16px;
        font-size: 20px;
        margin-top: 30px;
      }
      
      .detail-reward-setting-head {
        margin-top: 30px;
        display: flex;
        gap: 8px;
        .head-title {
          font-size: 24px;
          text-align: center;
        }
      }

      .border-styled {
        border-bottom: 2px solid #484B52;
        padding-bottom: 8px;
      }

      .detail-reward-setting-row {
        height: 325px;
        overflow: auto;
        margin-top: 8px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        scrollbar-gutter: stable;
        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        ::-webkit-scrollbar-track {
          border-radius: 10px;
          background: rgba(110, 109, 109, 0.1);
        }
        ::-webkit-scrollbar-thumb{
          border-radius: 10px;
          background: rgba(110, 109, 109, 0.34);
        }
        ::-webkit-scrollbar-thumb:hover{
          background: rgba(110, 109, 109, 0.34);
        }
        ::-webkit-scrollbar-thumb:active{
          background: rgba(110, 109, 109, 0.34);
        }
        .row-item {
          display: flex;
          align-items: center;
          gap: 24px;
        }
      }

      .color-DEDEDE {
        color: #DEDEDE;
      }

      .title-label {
        display: flex;
        align-items: center;
        font-size: 18px;
      }

      .request__red {
        color: red;
        padding-left: 5px;
      }

      .box-select {
        width: 100%;
        position: relative;
      }

      .select-name {
        color: #ffffff;
      }

      .box-btn {
        width: 100%;
        height: 50px;
        display: flex;

        .btn-prize-pool {
          padding-left: 20px;
        }
      }

      .disable-box {
        .align-items-center {
          background-color: #1e2236;
        }
      }

      .start-in-contain {
        display: flex;
        justify-content: space-between;
        position: relative;

        .child-start-in {
          width: 30%;
          position: relative;

          .pre-name {
            position: absolute;
            top: 8px;
            right: 15px;
            color: rgb(157, 157, 157);
            font-size: 18px;
          }
        }

        .text_error {
          position: absolute;
          top: 44px;
          color: #ff4d4f;
          font-size: 16px;
          width: 100%;
        }
      }

      .btn-create {
        display: flex;
        justify-content: center;
        padding-top: 20px;
        width: 100%;

        .ant-form-item {
          margin: 0;
        }
      }

      .ant-form-item-explain-error {
        font-size: 16px;
      }
    }
    .disabled-opacity {
      opacity: 0.3;
    }

    .merah {
      position: relative;
      color: white;
      font-size: 24px;
      .value-merah {
        position: absolute;
        top: -12px;
        left: 32px;
        width: 80px;
        color: #d9d9d9;
      }
      .error-validation {
        border: 1.5px solid red;
      }
      .search-input {
        background-color: ${({ theme }) => theme.color.transparent};
        border: none;

        font-size: 24px;
        line-height: 20px;
        color: ${({ theme }) => theme.color.white};

        &:focus {
          outline: none;
        }

        &::placeholder {
          color: ${({ theme }) => theme.color.grey};
        }
      }
    }

    .input-disabled {
      filter: brightness(0.5);
    }
    
    .text_error_race {
      position: absolute;
      top: 69px;
      color: #ff4d4f;
      font-size: 16px;
      width: 100%;
    }

    .btn-add {
      margin-top: 20px;
    }

    .line__guild--gradiant {
      height: 2px;
      padding: 8px 0;
      margin-top: 16px;
      img {
        width: 100%;
        height: 2px;
      }
    }

    .action {
      margin-top: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 80px;
    }
  }
`

export default ModalUserCreateRewardSettingStyled
